'use client';

import { createContext } from 'react';
import { CookieConsent } from './cookie-consent.types';


export type CookieConsentContextValue = {
    consent: CookieConsent | null
    saveConsent: (consent: CookieConsent) => Promise<void>
}

export const CookieConsentContext = createContext<CookieConsentContextValue | null>(null);
